import React, { useEffect, useState } from "react";

interface Props {
	id?: string;
	length: number;
	pattern?: string;
	placeholder: string;

	/**
	 * Definisce il value della input
	 */
	inputCode: string | undefined;

	codeHandler: (code: string) => void;
	inputRequired?: boolean;
	capitalize?: boolean;
	isInvalid?: boolean;
	autofocus?: boolean;
	disabled?: boolean;
}

const BftCodeInput: React.FC<Props> = (props) => {
	const {
		id,
		length,
		pattern,
		placeholder,
		inputCode,
		codeHandler,
		inputRequired,
		capitalize,
		isInvalid,
		autofocus,
		disabled,
	} = props;

	const [code, setCode] = useState<any>("");
	const [cursorPosition, setCursorPosition] = useState(0);

	const inputChangeHandler = (e: any) => {
		const selectionStart = e.target.selectionStart - 1;
		setCursorPosition(selectionStart);
		if (pattern) {
			const rule = new RegExp(pattern);
			if (rule.test(e.target.value)) {
				const newCode = e.target.value.toString();
				const value = capitalize ? newCode.toUpperCase() : newCode;
				setCode(value);
				codeHandler(value);
			}
		} else {
			const newCode = e.target.value.toString();
			const value = capitalize ? newCode.toUpperCase() : newCode;
			setCode(value);
			codeHandler(value);
		}
	};

	const caretHandler = (e: any) => {
		if (Array.from(String(code), String).length > e.target.selectionStart)
			setCursorPosition(e.target.selectionStart);
	};

	const backspaceHandler = (e: any) => {
		if (e.keyCode == 8) {
			e.preventDefault();

			const inputArray = Array.from(String(code), String);
			inputArray.splice(cursorPosition, 1);
			if (inputArray.length !== 0) {
				const newCode = String(inputArray.join(""));
				setCode(newCode);
				codeHandler(newCode.toString());
				setCursorPosition(cursorPosition - 1);
			}
			if (inputArray.length === 0) {
				setCode("");
				codeHandler("");
			}
		}
	};

	useEffect(() => {
		if (inputCode && inputCode.length === length) {
			setCursorPosition(length - 1);
		}
	}, []);

	useEffect(() => {
		setCode(inputCode);
	}, [inputCode]);

	return (
		<div className="container mb-2">
			<div className="code-input-container">
				<input
					id={`input-${id ? id : Math.ceil(Math.random() * 100000)}`}
					className={
						"ps-5 ms-0 code-input" + (length > 11 ? " extra-small" : length > 7 ? " small" : "")
					}
					type="text"
					minLength={1}
					maxLength={length}
					size={length}
					value={code}
					onKeyDown={backspaceHandler}
					onSelect={caretHandler}
					pattern={pattern}
					onChange={inputChangeHandler}
					required={inputRequired}
					autoFocus={autofocus}
					disabled={disabled}
					autoComplete="new-password"
				/>
				<label className="description-label">{placeholder}</label>

				<div className="view-code-input">
					{[...Array(length)].map((_, index) => (
						<div
							key={index}
							className={
								"fakeView" +
								(cursorPosition === index ? " carret" : "") +
								(length > 11 ? " extra-small" : length > 7 ? " small" : " regular")
							}
						>
							{code && code.toString()[index]}
						</div>
					))}
				</div>
			</div>
		</div>
	);
};

export default BftCodeInput;
